import { SettingsEndpoint } from "@constants/ApiEndpoints";
import { AxiosInstance } from "axios";
import { RoomLikeAndFeatureModel } from "models/Settings/Reservation/roomLikeAndFeature/RoomLikeAndFeatureModel";
import { FetchingRequestParamsModels } from "models/Shared/FetchingRequestParamsModels";

export const remove =
  (axios: AxiosInstance) =>
  async (id: number): Promise<RoomLikeAndFeatureModel> => {
    return await axios.delete(
      `${SettingsEndpoint.SETTINGS_RESERVATION_ROOM_LIKE_AND_FEATURE}/${id}`
    );
  };

export const getAll =
  (axios: AxiosInstance) =>
  async (
    params?: FetchingRequestParamsModels
  ): Promise<RoomLikeAndFeatureModel[]> => {
    return await axios
      .get(SettingsEndpoint.SETTINGS_RESERVATION_ROOM_LIKE_AND_FEATURE, {
        params,
      })
      .then(({ data }) => data.items);
  };

export const create =
  (axios: AxiosInstance) =>
  async (data: RoomLikeAndFeatureModel): Promise<RoomLikeAndFeatureModel> => {
    return await axios
      .post(SettingsEndpoint.SETTINGS_RESERVATION_ROOM_LIKE_AND_FEATURE, data)
      .then(({ data }) => data);
  };

export const update =
  (axios: AxiosInstance) =>
  async (data: RoomLikeAndFeatureModel): Promise<RoomLikeAndFeatureModel> => {
    return await axios
      .put(
        `${SettingsEndpoint.SETTINGS_RESERVATION_ROOM_LIKE_AND_FEATURE}/${data.id}`,
        data
      )
      .then(({ data }) => data);
  };

export const toggleStatus =
  (axios: AxiosInstance) =>
  async (id: number): Promise<RoomLikeAndFeatureModel> => {
    return await axios
      .patch(
        `${SettingsEndpoint.SETTINGS_RESERVATION_ROOM_LIKE_AND_FEATURE}/${id}`
      )
      .then(({ data }) => data);
  };
